import { Check, X } from "lucide-react";

// Slugify helper for heading anchors
const slug = (s) =>
  String(s)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

const Block = ({ block }) => {
  switch (block.type) {
    case "h2":
      return (
        <h2 id={slug(block.text)} className="sl-article__h2">
          {block.text}
        </h2>
      );
    case "h3":
      return (
        <h3 id={slug(block.text)} className="sl-article__h3">
          {block.text}
        </h3>
      );
    case "p":
      return <p className="sl-article__p">{block.text}</p>;
    case "ul":
      return (
        <ul className="sl-article__list">
          {block.items.map((it, i) => (
            <li key={i}>{it}</li>
          ))}
        </ul>
      );
    case "ol":
      return (
        <ol className="sl-article__list sl-article__list--ordered">
          {block.items.map((it, i) => (
            <li key={i}>{it}</li>
          ))}
        </ol>
      );
    case "pros":
      return (
        <ul className="sl-article__pc sl-article__pc--pros">
          {block.items.map((it, i) => (
            <li key={i}>
              <Check size={16} strokeWidth={2.6} />
              <span>{it}</span>
            </li>
          ))}
        </ul>
      );
    case "cons":
      return (
        <ul className="sl-article__pc sl-article__pc--cons">
          {block.items.map((it, i) => (
            <li key={i}>
              <X size={16} strokeWidth={2.6} />
              <span>{it}</span>
            </li>
          ))}
        </ul>
      );
    case "quote":
      return <blockquote className="sl-article__quote">{block.text}</blockquote>;
    case "features":
      return (
        <div className="sl-article__features">
          {block.items.map((f, i) => (
            <div key={i} className="sl-article__feature">
              <div className="sl-article__feature-title">{f.title}</div>
              <div className="sl-article__feature-text">{f.text}</div>
            </div>
          ))}
        </div>
      );
    case "table": {
      const hi = block.highlightRow;
      return (
        <div className="sl-article__table-wrap">
          <table className="sl-article__table">
            <thead>
              <tr>
                {block.headers.map((h, i) => (
                  <th key={i}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {block.rows.map((row, r) => (
                <tr key={r} className={hi === r ? "is-highlight" : ""}>
                  {row.map((cell, c) => (
                    <td key={c}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
    default:
      return null;
  }
};

const ArticleBlocks = ({ blocks }) => {
  return (
    <div className="sl-article__body" data-testid="article-body">
      {blocks.map((b, i) => (
        <Block key={i} block={b} />
      ))}
    </div>
  );
};

export default ArticleBlocks;
